<template>
  <div>
    <b-row class="below" v-if="grp_type == '2' || std_type_code == '3'">
      <b-col sm="2" lg="2">지문</b-col>
      <b-col v-html="jimun"></b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '3'">
      <b-col sm="2" lg="2">지문 단어수</b-col>
      <b-col v-html="jimun_count"></b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '3'">
      <b-col sm="2" lg="2">원문</b-col>
      <b-col v-html="plain_jimun"></b-col>
    </b-row>
    <b-row class="below" v-if="std_type_code == '3'">
      <b-col sm="2" lg="2">원문 단어수</b-col>
      <b-col v-html="jimun_count"></b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code == '3'">
      <b-col sm="2" lg="2">(지문)소재</b-col>
      <b-col v-html="plain_jimun_subject_text"></b-col>
    </b-row>
    <b-row class="below" v-if="std_type_code == '3'">
      <b-col sm="2" lg="2">(지문)난이도</b-col>
      <b-col v-html="plain_jimun_level"></b-col>
    </b-row>
    <div v-if="std_type_code == '3'">
      <b-row class="below" :key="item.id" v-for="(item, idx) in jimunwords">
        <b-col sm="2" lg="2">어휘주석{{ idx + 1 }}</b-col>
        <b-col v-html="item.word"></b-col>
        <b-col v-html="item.comment"></b-col>
      </b-row>
    </div>

    <b-row class="below" v-if="std_type_code == '2' || std_type_code == '3'">
      <b-col sm="2" lg="2">해석</b-col>
      <b-col v-html="translate"></b-col>
    </b-row>

    <b-row class="below" v-if="std_type_code != '3'">
      <b-col sm="2" lg="2">해설</b-col>
      <b-col v-html="qcomment"></b-col>
    </b-row>
  </div>
</template>

<script>
import * as _ from "lodash";
export default {
  computed: {
    std_type_code() {
      return this.$store.state.questionmeta.std_type;
    },

    grp_type() {
      return this.$store.state.questionmeta.grp_type;
    },
    jimun() {
      if (this.grp_type == "1") {
        return this.$store.state.questionmeta.jimun;
      } else {
        return this.$store.state.questionmeta.jimun;
      }
    },

    plain_jimun() {
      return this.$store.state.questionmeta.plain_jimun;
    },

    jimun_count() {
      // return 25;
      return this.$store.state.questionmeta.jimun_word_count;
    },
    plain_jimun_count() {
      // return 25;
      return this.$store.state.questionmeta.plain_jimun_word_count;
    },

    plain_jimun_subject() {
      return this.$store.state.questionmeta.plain_jimun_subject;
    },
    plain_jimun_subject_text() {
      try {
        let cd = this.$store.state.questionmeta.plain_jimun_subject;
        let jimun_subject_options = this.$store.state.jimun_subject_options;
        let k = _.find(jimun_subject_options, function (o) {
          return o.value == cd;
        });
        return k.text;
      } catch {
        return "";
      }
    },

    plain_jimun_level() {
      return "level" + this.$store.state.questionmeta.plain_jimun_level;
    },

    jimunwords() {
      return this.$store.state.questionmeta.jimunwords;
    },

    translate() {
      if (this.grp_type == "1") {
        return this.$store.state.questionmeta.translate;
      } else {
        return this.$store.state.questionmeta.translate;
      }
    },
    qcomment() {
      if (this.grp_type == "1") {
        return this.$store.state.questionmeta.qcomment;
      } else {
        return this.$store.state.questionmeta.qcomment;
      }
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.below {
  padding-bottom: 6px;
  padding-top: 6px;
  border-bottom: 1px solid $gray100;
}
</style>